import { Component, OnInit } from '@angular/core';
import {
  ButtonClassesEnum,
  IButtonModel,
  IClassesAttributes,
  IconClassesEnum,
} from '@types-custom/models/ui/button-model';
import { Icon } from '@types-custom/models/ui/icon-model';
import {ODMatrixFilteredTypesEnum} from "@shared/models/ODMatrix/ODMatrix.model";
import {ODMatrizService} from "@shared/services/odmatriz-service/odmatriz.service";

@Component({
  selector: 'cdm-almeria-map-filter-period-matrix-od',
  templateUrl: './map-filter-period-matrix-od-camera.component.html',
  styleUrls: ['./map-filter-period-matrix-od-camera.component.scss'],
})
export class MapFilterPeriodMatrixODCameraComponent implements OnInit{
  Icon=Icon;
  buttonTag = 'BUSCAR';
  buttonAttributes: IButtonModel = {};
  restorebuttonAttributes: IButtonModel = {};
  applybuttonAttributes : IButtonModel = {};

  percentageFilters  = '1h'
  SelectedFilterOptions : any[] = []

  constructor(
    private ODMatrixService : ODMatrizService
  ) {
  }

  ngOnInit(): void {
    this.generateValues();
    this.generateButtonAttributes();
    this.reloadData()
  }

  public selectPercentage(id : string) {
    this.percentageFilters = id
  }

  private generateButtonAttributes(): void {
    this.buttonAttributes = {
      label: this.buttonTag,
      postIcon: Icon.search_w,
      classAttributes: {
        buttonClass: ButtonClassesEnum.primary_1_button_filter_custom,
      },
    };
    this.restorebuttonAttributes = {
      label: 'RESTABLECER',
      postIcon: undefined,
      classAttributes: {
        buttonClass: ButtonClassesEnum.transparent_button_2_custom,
        iconClass:IconClassesEnum.text_white_panel
      },
    };
    this.applybuttonAttributes = {
      label: 'APLICAR',
      postIcon: undefined,
      classAttributes: {
        buttonClass: ButtonClassesEnum.primary_1_button_filter_custom,
      },
    };
  }

  ExitsOnArray(item: any) {
    return (this.percentageFilters === item)
  }

  private generateValues() {
    this.SelectedFilterOptions = [
      {id : '1h' , value : '1 Hora'},
      {id : '1d' , value : '1 Día'},
      {id : '1m' , value : '1 Mes'},

      {id : '6h' , value : '6 Horas'},
      {id : '2d' , value : '2 Días'},
      {id : '2m' , value : '2 Meses'},

      {id : '12h' , value : '12 Horas'},
      {id : '5d' , value : '5 Días'},
      {id : '3m' , value : '3 Meses'},

      {id : '24h' , value : '24 Horas'},
      {id : '10d' , value : '10 Días'},
      {id : '' , value : ''},

      {id : '48h' , value : '48 Horas'},
      {id : '15d' , value : '15 Días'},
      {id : '' , value : ''},

      {id : '' , value : ''},
      {id : '30d' , value : '30 Días'},
      {id : '' , value : ''},
    ]
  }

  public sendValues(type : boolean) {
    if(type) {
      this.percentageFilters = '1h'
    }

    document.querySelector<HTMLElement>('#Periodo').click();

    (type) ? document.querySelector<HTMLElement>('#Periodo').parentElement.classList.remove('applied-filter') :
      document.querySelector<HTMLElement>('#Periodo').parentElement.classList.add('applied-filter');
    this.ODMatrixService.sensorFilterDatesSubject.next(
      {
        type : ODMatrixFilteredTypesEnum.CAMERA_PEDIOD,
        values : {
          timestamp : this.percentageFilters
        }
      }
    )
  }

  private reloadData() {
    this.ODMatrixService.filteredDatesSensor$.subscribe((res : any) => {
      if(res?.type === ODMatrixFilteredTypesEnum.CAMERA_PEDIOD) {
        this.percentageFilters = res.values.timestamp
      }
    })
  }
}
